module.exports = __webpack_public_path__ + "img/CASINOWINNER.db43d4bc.svg";